import "./GroupOptions.styles.scss";
import { Avatar } from "components";
import { components } from "react-select";
import React from "react";

export const GroupOption = ({ showAvatar = false, ...props }) => {
  const { label, isSelected, isMulti } = props;
  return (
    <components.Option {...props}>
      <div className="group-option">
        {isMulti && (
          <input type="checkbox" checked={isSelected} onChange={() => null} />
        )}{" "}
        {showAvatar && (
          <div className="group-avatar-wrapper">
            <Avatar fullName={label} />
          </div>
        )}
        <p className="group-option-label">{label}</p>
      </div>
    </components.Option>
  );
};

export const allGroupsOption = {
  label: "Select all groups",
  value: "*",
};

export const ValueContainer = ({ children, ...props }) => {
  const currentValues = props.getValue();
  let toBeRendered = children;
  if (currentValues.some((val) => val.value === allGroupsOption.value)) {
    toBeRendered = [[children[0][0]], children[1]];
  }

  return (
    <components.ValueContainer {...props}>
      {toBeRendered}
    </components.ValueContainer>
  );
};

export const MultiValue = (props) => {
  let labelToBeDisplayed = `${props.data.label}`;
  if (props.data.value === allGroupsOption.value) {
    labelToBeDisplayed = "All groups";
  }
  return (
    <components.MultiValue {...props}>
      <span>{labelToBeDisplayed}</span>
    </components.MultiValue>
  );
};
